import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

import { getErrorMessageBannerStyles } from '../styles/error-message-banner-styles';
import { InfoIcon } from './icons';

export const ErrorMessageBanner = ({ errorMessage }) => {
  const classes = useDefaultStyles(getErrorMessageBannerStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const i18n = useContext(I18nContext);

  if (!errorMessage) {
    return null;
  }

  return (
    <div className={classNames('error-message-container', classes.container, classes[`container-${displayMode}`])}>
      <div className={classNames('icon-container', classes.iconContainer)}>
        <InfoIcon />
      </div>
      <span className={classNames('error-text', classes.errorText, classes[`errorText-${displayMode}`])}>
        {i18n.getString(errorMessage)}
      </span>
    </div>
  );
};

ErrorMessageBanner.propTypes = {
  errorMessage: PropTypes.string,
};

ErrorMessageBanner.defaultProps = {
  errorMessage: '',
};
